export default {
      id: "no-tasks-usage",
      viewBox: "0 0 99 80",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#no-tasks",
      toString: function () {
        return this.url;
      }
    }